/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkCarveOutsManuallySubmittedRequest
 */
export interface MarkCarveOutsManuallySubmittedRequest {
    /**
     * Restrict the action to these carve-outs. Omit to mark every complete, deferred carve-out on the submission.
     */
    carve_out_ids?: Array<string>;
    /**
     * 
     */
    reason?: string;
}

/**
 * Check if a given object implements the MarkCarveOutsManuallySubmittedRequest interface.
 */
export function instanceOfMarkCarveOutsManuallySubmittedRequest(value: object): value is MarkCarveOutsManuallySubmittedRequest {
    return true;
}

export function MarkCarveOutsManuallySubmittedRequestFromJSON(json: any): MarkCarveOutsManuallySubmittedRequest {
    return MarkCarveOutsManuallySubmittedRequestFromJSONTyped(json, false);
}

export function MarkCarveOutsManuallySubmittedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkCarveOutsManuallySubmittedRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carve_out_ids': json['carve_out_ids'] == null ? undefined : json['carve_out_ids'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MarkCarveOutsManuallySubmittedRequestToJSON(json: any): MarkCarveOutsManuallySubmittedRequest {
    return MarkCarveOutsManuallySubmittedRequestToJSONTyped(json, false);
}

export function MarkCarveOutsManuallySubmittedRequestToJSONTyped(value?: MarkCarveOutsManuallySubmittedRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carve_out_ids': value['carve_out_ids'],
        'reason': value['reason'],
    };
}

